import { useContext } from 'react';

import AppContext from '@/contexts/appContext';
import { RemitFinancialInfo, RemitFinancialInfoPayload } from '@/types/billing';
import PaginatedResponse from '@/types/paginatedResponse';
import RepositoryResponse from '@/types/repositoryResponse';

import { createRepository } from './GenericRepository';

const basePath = '/api/billing/remit_financial_info';

export const remitFinancialInfoRepository = createRepository<
  RemitFinancialInfo,
  RemitFinancialInfoPayload
>(basePath);

const RemitFinancialInfoRepository = () => {
  const { host } = useContext(AppContext);

  return {
    async list(
      params: Record<string, string> = {}
    ): Promise<RepositoryResponse<PaginatedResponse<RemitFinancialInfo[]>>> {
      return remitFinancialInfoRepository.list({ host, params });
    },

    async get({ id }: { id: string }): Promise<RepositoryResponse<RemitFinancialInfo>> {
      return remitFinancialInfoRepository.get({ host, id });
    },
    async create({ data }: { data: RemitFinancialInfoPayload }): Promise<RemitFinancialInfo> {
      return remitFinancialInfoRepository.create({ host, data });
    },
    async update({
      id,
      data
    }: {
      id: string;
      data: RemitFinancialInfoPayload;
    }): Promise<RemitFinancialInfo> {
      return remitFinancialInfoRepository.update({ host, id: id, data });
    },
    async delete({ id }: { id: string }) {
      return remitFinancialInfoRepository.delete({ host, id });
    }
  };
};

export default RemitFinancialInfoRepository;
